import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import logo from "../assets/images/6.png";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="flex justify-center items-center absolute top-0 z-30 w-full flex-col">
      {/* For Responsive Navbar  */}

      <nav className="bg-transparent w-full">
        <div className="w-full flex flex-wrap items-center justify-between lg:justify-start  xl:justify-between  mx-auto  p-4 lg:py-5">
          <a
            href="/"
            className="flex  lg:w-[30%] xl:w-1/5  justify-center items-center  space-x-3 lg:me-0 2xl:ms-20 rtl:space-x-reverse"
          >
            <img src={logo} className="me-10 w-60" alt="Flowbite Logo" />
          </a>
          <div>
            <button
              onClick={() => setIsOpen(!isOpen)} aria-labelledby="open close button"
              className="inline-flex items-center p-2 w-10 h-10 justify-center  text-white  lg:hidden  focus:outline-none"
            >
                {
                    isOpen ? <ClearIcon className="text-3xl" fontSize="2rem" /> : <MenuIcon className="text-3xl" fontSize="2rem"  />
                }
              
            </button>

            <span className="inline-flex mx-2 lg:hidden text-center ">
              <SearchIcon className="text-white text-3xl" fontSize="2rem" />
            </span>
            <span className="inline-flex bolck lg:hidden text-center ">
              <WorkOutlineIcon className="text-white text-3xl" fontSize="2rem" />
            </span>
          </div>
          <div
            className={`${
              isOpen ? "block" : "hidden"
            } w-full lg:flex lg:justify-center bg-white lg:bg-transparent rounded-3xl lg:mt-0 mt-4  flex-col lg:flex-row lg:w-[60%] `}
            id="navbar-default"
          >
            <ul className="font-bold flex flex-col p-4  mt-4  rounded-lg lg:flex-row lg:space-x-8 rtl:space-x-reverse lg:mt-0 ">
              <li>
                <a
                  href="/"
                  className="block py-2.5 px-3 text-[16px] lg:w-20 font-outfit lg:border-b-0 border-b-[1px] border-black md:py-3.5 md:px-6 lg:text-[#fff] font-[400] lg:bg-transparent  lg:p-0"
                  aria-current="page"
                >
                  Home 1
                </a>
              </li>
              <li>
                <a
                  href="/home-2"
                  className="block py-2.5 px-3 text-[16px] lg:w-20 font-outfit md:py-3.5  lg:border-b-0 border-b-[1px] border-black md:px-6 lg:text-[#fff] font-[400]  hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-[#CFA649] lg:p-0"
                >
                 Home 2
                </a>
              </li>
              <li>
                <a
                  href="#/"
                  className="block py-2.5 px-3 text-[16px] lg:w-20 font-outfit md:py-3.5  lg:border-b-0 border-b-[1px] border-black md:px-6 lg:text-[#fff] font-[400]  hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-[#CFA649] lg:p-0"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="#/"
                  className="block py-2.5 px-3 text-[16px] lg:w-20 font-outfit md:py-3.5  lg:border-b-0 border-b-[1px] border-black md:px-6 lg:text-[#fff] font-[400]  hover:bg-gray-100 md:hover:bg-transparent md:hover:text-[#CFA649] lg:p-0"
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="#/"
                  className="block py-2.5 px-3 text-[16px] font-outfit md:py-3.5 md:px-6   lg:text-[#fff] font-[400]  hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 md:hover:text-[#CFA649] lg:p-0"
                >
                  Contact
                </a>
              </li>
              <li className="mx-4  ">
                <a
                  href="#/" aria-label="search"
                  className="lg:block hidden py-2 px-4 mx-4 text-[16px] font-outfit md:py-3.5 md:px-6 lg:text-[#fff] font-[400] rounded-sm hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 md:hover:text-[#CFA649] lg:p-0"
                >
                  <SearchIcon />
                </a>
              </li>
              <li>
                <a
                  href="#/" aria-label="cart"
                  className="lg:block hidden py-2 px-4 text-[16px] font-outfit md:py-3.5 md:px-6 text-[#fff] font-[400]  hover:bg-gray-100 lg:hover:bg-transparent lg:border-0 md:hover:text-[#CFA649] lg:p-0"
                >
                  <WorkOutlineIcon />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
